var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5638 0.5C14.7939 0.5 15.8017 1.45186 15.8907 2.65919L15.8971 2.83333V21.5H8.89713V2.83333C8.89713 1.60324 9.84899 0.595474 11.0563 0.5064L11.2305 0.5H13.5638ZM21.7305 6.33333C23.0192 6.33333 24.0638 7.378 24.0638 8.66667V19.1667C24.0638 20.4554 23.0192 21.5 21.7305 21.5H18.2305V6.33333H21.7305ZM6.5638 9.83333V21.5H3.0638C1.77514 21.5 0.730469 20.4554 0.730469 19.1667V12.1667C0.730469 10.878 1.77514 9.83333 3.0638 9.83333H6.5638Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/statistics-icon.d239c64af53028fe82b1896583b065c6.svg";
export { ForwardRef as ReactComponent };